<div class="container-fluid">
  <div class="row">

    <a 
      class="col-12 bg-white py-3 px-3 rounded mb-4 text-decoration-none text-dark" 
      [routerLink]="['/neighborhoods', charge!.neighborhoodId, 'payments', charge!.chargeId]">
      <div class="row">

        <div class="col d-flex align-items-center">
          <h4 class="m-0">
            <b>{{ charge?.createdAt | dateToMoment: 'MMMM YYYY' }}</b>
            @if (duplicateIndex) {
              <span class="badge bg-warning text-dark ms-2">#{{ duplicateIndex }}</span>
            }
          </h4>
        </div>

        <div class="col">
          <div class="row">

            <div class="col text-danger d-flex align-items-center">
              <i class="material-icons me-2">cancel</i>{{ charge?.overdue }}
            </div>
            <div class="col text-secondary d-flex align-items-center">
              <i class="material-icons me-2">pending</i>{{ charge?.pending }}
            </div>
            <div class="col text-success d-flex align-items-center">
              <i class="material-icons me-2">check_circle</i>{{ charge?.done }}
            </div>

          </div>
        </div>

        <div class="col text-center">
          {{ charge?.charge | currency }}
        </div>

        <div class="col d-flex justify-content-end align-items-center">
          <button
            class="btn btn-link text-danger p-0 m-0"
            (click)="delete(); $event.stopPropagation(); $event.preventDefault()">
            <i class="material-icons">delete</i>
          </button>
        </div>

      </div>
    </a>

  </div>
</div>